import { ReactElement, useMemo, useState } from 'react';
import dayjs from 'dayjs';
import { sortBy } from 'lodash';

import { Typography } from '1_shared/ui';

import { IExpOpenConfig } from './interfaces/IExpOpenConfig';

import styles from './SpecialistExperienceData.module.scss';
import { Popover } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';
import { declination, yearTitles } from '../../../1_shared/helpers/declination';

import { ISpecialistAchievementsCardProps } from '../../../1_shared/config/interfaces/ISpecialistAchievementsCardProps';
import ExpandBtn from './components/ExpandBtn';

const minShowAchievements = 3;

// TODO: необходим рефакторинг компонента

/*
 * TODO: контент компонента Popover заменить на приходящий с бекенда
 * Сам компонент popover вынести в слой шаред
 */
const TULTIP_BLUE_COLOR = '#E6F6FF';
const TULTIP_WHITE_COLOR = '#FFFFFF';

const SpecialistExperienceData = ({
  spec,
  descriptions,
  isMobile = false,
}: ISpecialistAchievementsCardProps): ReactElement => {
  const [openExp, setOpenExp] = useState<IExpOpenConfig>({
    exp: false,
    jobs: false,
  });

  const workMethods = spec.workMethods;

  const jobs = useMemo(
    () => sortBy(spec.jobExperiences, job => job.dateFrom).reverse(),
    [spec.jobExperiences],
  );

  const jobsYears = (
    <>
      {[...jobs]
        .slice(0, openExp.jobs ? jobs.length : minShowAchievements)
        .map(job => (
          <div key={job.position} className={styles.gridBlock}>
            <Typography type="description" className={styles.year}>
              {dayjs(job.dateFrom).format('YYYY')}
            </Typography>
            <Typography>
              {`${job.city}, ${job.company}, ${job.position}`}
            </Typography>
          </div>
        ))}
    </>
  );

  const edu = useMemo(
    () =>
      sortBy(
        [
          ...(spec?.educations || []),
          ...(spec?.certificates || []),
          ...(spec?.trainings || []),
          ...(spec?.professionalRetrainings || []),
        ].map((elem: any) => ({
          ...elem,
          date: elem?.dateFrom || elem.issuedAt,
        })),
        el => el.date,
      ).reverse(),
    [spec],
  );

  const getData = (ed: any) =>
    ('issuedAt' in ed && ed?.issuedAt) || ('dateFrom' in ed && ed?.dateFrom)
      ? dayjs('dateFrom' in ed ? ed?.dateFrom : ed?.issuedAt).format('YYYY')
      : '-';

  return (
    <div className={styles.root}>
      <div className={styles.cardContent}>
        <Typography type="textM" className={styles.headerText}>
          Методы работы
        </Typography>
        <div className={styles.wrappedWorkMethodsData}>
          {descriptions.length &&
            descriptions.map(methodItem => (
              <div key={methodItem.id} className={styles.workMethod}>
                <div className={styles.text}>{methodItem.label}</div>
                <Popover
                  color={isMobile ? TULTIP_WHITE_COLOR : TULTIP_BLUE_COLOR}
                  placement={'topRight'}
                  arrow={false}
                  destroyTooltipOnHide
                  styles={{
                    root: {
                      width: isMobile ? '90%' : '560px',
                      height: 'auto',
                    },
                  }}
                  content={methodItem.description}
                  title={methodItem.label}
                  trigger="click"
                >
                  <InfoCircleFilled className={styles.infoButton} />
                </Popover>
              </div>
            ))}
        </div>
      </div>
      {!!jobs.length && (
        <div className={styles.expandableCard}>
          <div className={styles.cardContent}>
            <Typography type="textM" className={styles.headerText}>
              Опыт{' '}
              {spec?.experience &&
                `${spec.experience} ${declination(parseInt(spec.experience), yearTitles)}`}
            </Typography>
            <div className={styles.wrapperData}>{jobsYears}</div>
          </div>
          <ExpandBtn
            dataLength={jobs.length}
            minCountForShow={minShowAchievements}
            isOpened={openExp.jobs}
            method={() => {
              setOpenExp({
                exp: false,
                jobs: !openExp.jobs,
              });
            }}
          />
        </div>
      )}
      {!!edu.length && (
        <div className={styles.expandableCard}>
          <div className={styles.cardContent}>
            <Typography type="textM" className={styles.headerText}>
              Образование
            </Typography>
            <div className={styles.wrapperData}>
              {[...edu]
                .slice(0, openExp.exp ? edu.length : minShowAchievements)
                .map(ed => (
                  <div
                    key={'university' in ed ? ed.university : ed.title}
                    className={styles.gridBlock}
                  >
                    <Typography type="description" className={styles.year}>
                      {getData(ed)}
                    </Typography>
                    <Typography>
                      {`${'university' in ed ? ed.university : ed.title}, ${'specialization' in ed ? ed.specialization : ed.issuer}`}
                    </Typography>
                  </div>
                ))}
            </div>
          </div>

          <ExpandBtn
            dataLength={edu.length}
            minCountForShow={minShowAchievements}
            isOpened={openExp.exp}
            method={() => {
              setOpenExp({
                exp: !openExp.exp,
                jobs: false,
              });
            }}
          />
        </div>
      )}
    </div>
  );
};
export default SpecialistExperienceData;
